
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { X, ChevronDown, ChevronUp } from "lucide-react";

const CookieNotice = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Check if the notice has been accepted before
    const hasAccepted = localStorage.getItem("cookieNoticeAccepted");
    if (!hasAccepted) {
      // Show the notice if not accepted before
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    // Save to localStorage so we don't show it again
    localStorage.setItem("cookieNoticeAccepted", "true");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-slideUp">
      <div className="container mx-auto max-w-md">
        <Alert className="bg-white border border-gray-200 shadow-md rounded-lg">
          <AlertTitle className="text-base font-medium text-[#006B5F] mb-2 flex justify-between items-center">
            {t('cookies.title')}
            <Button
              variant="ghost"
              size="sm"
              className="h-6 w-6 p-0 rounded-full"
              onClick={handleAccept}
            >
              <X className="h-3 w-3 text-gray-500" />
              <span className="sr-only">{t('cookies.close')}</span>
            </Button>
          </AlertTitle>
          <AlertDescription className="text-sm text-gray-700">
            <p>{t('cookies.descriptionShort')}</p>

            {showDetails && (
              <div className="mt-2 text-xs text-gray-600 space-y-1">
                <p>{t('cookies.descriptionDetails')}</p>
              </div>
            )}

            <div className="mt-3 flex gap-2 items-center">
              <Button
                onClick={handleAccept}
                size="sm"
                className="bg-[#006B5F] hover:bg-[#005a50] text-white"
              >
                {t('cookies.accept')}
              </Button>
              <Button
                onClick={() => setShowDetails(!showDetails)}
                variant="ghost"
                size="sm"
                className="text-[#006B5F] hover:text-[#005a50] text-xs"
              >
                {showDetails ? (
                  <>
                    {t('cookies.showLess')} <ChevronUp className="ml-1 h-3 w-3" />
                  </>
                ) : (
                  <>
                    {t('cookies.readMore')} <ChevronDown className="ml-1 h-3 w-3" />
                  </>
                )}
              </Button>
            </div>
          </AlertDescription>
        </Alert>
      </div>
    </div>
  );
};

export default CookieNotice;
